//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PipeSystemDrawer from "./modules/PipeSystemDrawer";
import ManholeCoverList from "./ManholeCoverList";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryAreaTreeList, queryUserTreeList } from '@/api/api';
export default {
  name: 'PipeSystemList',
  mixins: [JeecgListMixin],
  components: {
    PipeSystemDrawer: PipeSystemDrawer,
    ManholeCoverList: ManholeCoverList
  },
  data: function data() {
    return {
      autoLoadInit: false,
      pagePath: '/sys/pipe/system',
      pageTitle: '管网登记',
      showAddBtn: false,
      siteId: '',
      siteName: '',
      areaTree: [],
      userTree: [],

      /*siteColumn: {
        dataIndex: 'paramName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true,
      },*/
      // 表头
      columns: [{
        dataIndex: 'mn',
        colName: 'mn',
        title: '编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '责任人',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'areaName',
        colName: 'area_id',
        title: '行政区域',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTree();
    this.loadData();
  },
  watch: {
    /*currentSiteId(value) {
      this.siteId = value
      this.loadData()
    },
    currentSiteName(value) {
      this.siteName = value
    },*/
  },
  computed: {},
  methods: {
    searchQuery: function searchQuery() {
      // debugger
      this.loadData(1);
    },
    searchReset: function searchReset() {
      this.queryParam = {};
      this.queryParam.permissionId = this.permId;
      /**/

      this.loadData(1);
    },
    onClose: function onClose() {
      this.visible = false;
    },
    // loadData(arg) {
    //  /* var ids = this.getTreeCurrentId()
    //   this.queryParam.type = ids[0]
    //   this.queryParam.id = ids[1]
    //   if (ids[0] == 1) {
    //     // 根据站点id
    //     this.spliceColumn(this.siteColumn)
    //     this.showAddBtn = false
    //   } else {
    //     // 根据区域id
    //     this.spliceColumn(this.siteColumn, 1)
    //     this.showAddBtn = true
    //   }*/
    //   this.initTableData(1)
    // },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.treeData = [];
      that.areaTree = [];
      queryAreaTreeList({
        status: '1'
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.areaTree.push(temp);
          }
        }
      }); // 获取负责人

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this.userTree.push(temp);
          }
        }
      });
    },
    handleAdd_: function handleAdd_() {
      this.handleAdd();
      this.$refs.modalForm.add(this.siteId, this.siteName);
    },
    handleManhole: function handleManhole(pipeSystemId, pointList) {
      this.$refs.modalManhole.refresh(pipeSystemId, pointList);
      this.$refs.modalManhole.title = this.$store.state.projectCode == 'meitang' ? this.title = '编辑：化粪池' : '编辑：窨井';
      this.$refs.modalManhole.showTab = true;
      this.$refs.modalManhole.showContact = true;
    }
  }
};